import { render, staticRenderFns } from "./PdfBookingLayoutSkeleton.vue?vue&type=template&id=746ff784&scoped=true&"
import script from "./PdfBookingLayoutSkeleton.vue?vue&type=script&lang=js&"
export * from "./PdfBookingLayoutSkeleton.vue?vue&type=script&lang=js&"
import style0 from "./PdfBookingLayoutSkeleton.vue?vue&type=style&index=0&id=746ff784&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "746ff784",
  null
  
)

export default component.exports